module.exports = __webpack_public_path__ + "img/kubernetes-black.3e32c1a8.svg";